import { render } from "./property-history.vue?vue&type=template&id=0f94b90c"
import script from "./property-history.js?vue&type=script&lang=js"
export * from "./property-history.js?vue&type=script&lang=js"

import "./property-history.vue?vue&type=style&index=0&id=0f94b90c&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__